import { Link } from "react-router-dom"
import { FaDiscord, FaInstagram, FaXTwitter } from "react-icons/fa6"

const socialLinks = [
  {
    name: "X",
    href: "https://x.com/Case_RTP",
    icon: FaXTwitter,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/case_rtp/",
    icon: FaInstagram,
  },
  {
    name: "Discord",
    href: "https://discord.gg/s86hAj7gD4",
    icon: FaDiscord,
  },
]

export default function Footer() {
  return (
    <footer className="border-t border-[#2A2D31]/50 bg-[#0A0C10]/80 backdrop-blur-sm py-8 relative z-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="md:w-1/3">
            <div className="flex items-center gap-2 mb-4 group">
              <div className="relative">
                <img src="/images/websitelogo/CaseRTP.svg" alt="CaseRTP logo" className="h-8 w-8 object-contain" />
              </div>
              <span className="text-xl font-bold font-display">CaseRTP</span>
            </div>
            <p className="text-blue-100/70 text-sm">
              CaseRTP is an independent comparison platform for CS2 & Rust case opening sites. We help players compare RTP, platform features, promotions and publicly available information in one place making it easier to make informed decisions.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-medium mb-3 font-display">Navigation</h3>
              <ul className="space-y-2 text-sm text-blue-100/70">
                <li>
                  <Link to="/" className="hover:text-[#FF6B00] transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/websites" className="hover:text-[#FF6B00] transition-colors">
                    Websites
                  </Link>
                </li>
                <li>
                  <Link to="/bonuses" className="hover:text-[#FF6B00] transition-colors">
                    Bonuses
                  </Link>
                </li>
                <li>
                  <Link to="/best-cases" className="hover:text-[#FF6B00] transition-colors">
                    Best Cases
                  </Link>
                </li>
                <li>
                  <Link to="/giveaways" className="hover:text-[#FF6B00] transition-colors">
                    Giveaways
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="hover:text-[#FF6B00] transition-colors">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-medium mb-3 font-display">Legal</h3>
              <ul className="space-y-2 text-sm text-blue-100/70">
                <li>
                  <Link to="/terms-of-service" className="hover:text-[#FF6B00] transition-colors">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-medium mb-3 font-display">Socials</h3>
              <div className="flex flex-col items-start gap-2">
                {socialLinks.map(({ name, href, icon: Icon }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Follow CaseRTP on ${name}`}
                    title={name}
                    className="inline-flex items-center gap-2 py-1 text-sm text-blue-100/70 transition-colors hover:text-[#FF6B00]"
                  >
                    <Icon className="h-4 w-4" aria-hidden="true" />
                    <span>{name}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#2A2D31]/50 mt-8 pt-6 text-center text-sm text-blue-100/50">
          <p>© {new Date().getFullYear()} CaseRTP. All rights reserved.</p>
          <p className="mt-2">
            CaseRTP is not affiliated with Valve Corporation, Facepunch, Steam, CS or Rust.
          </p>
        </div>
      </div>
    </footer>
  )
}
